import {
  ACTIVITY_LOG_FETCH_REQUEST,
  ACTIVITY_LOG_FETCH_REQUEST_SUCCESS,
  ACTIVITY_LOG_FETCH_REQUEST_FAILURE,
  ACTIVITY_LOG_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  totalApprovedAmount: '',
  totalApprovedCount: '',
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const activityLogReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case ACTIVITY_LOG_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case ACTIVITY_LOG_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data.data || action.data,
        errors: {},
        totalApprovedAmount: action.data.totalApprovedAmount || 0,
        totalApprovedCount: action.data.totalApprovedCount || 0,
        pagination: {
          current: action.data.currentPage || 0,
          pageSize: action.data.pageSize || 0,
          total: action.data.totalRecord || 0,
          totalPage: action.data.totalPage || 0,
          // pageSizeOptions: ['5', '10', '15', '20'],
          showSizeChanger: true,
        },
      });

    case ACTIVITY_LOG_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case ACTIVITY_LOG_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {},
        totalApprovedAmount: '',
        totalApprovedCount: '',
      });

    default:
      return state;
  }
};

export default activityLogReducer;
